import { getSignInUrl } from "@app/config/getServiceUrl";
import { fetchUserInfo } from "@features/auth/api/request";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: async ({ context }) => {
    try {
      const userInfo = await fetchUserInfo();
      if (userInfo) {
        context.queryClient.setQueryData(["userInfo"], userInfo);
        return;
      }
    } catch {}

    if (typeof window !== "undefined") {
      window.location.href = getSignInUrl({ redirectUrl: window.location.href });
    }
  },
  component: () => <Outlet />,
});
